module.exports = __webpack_public_path__ + "img/google-icon.14137f89.svg";